<p-dialog [header]="'priceCalculatorDialog.priceCalculator' | transloco" [(visible)]="showDialog" [modal]="true" [style]="{ 'width': '660px' }"
  (onHide)="onDialogClose($event)">
  <form class="form-horizontal py-3 px-4">
    <div class="row">
      <div class="col-6">
        <div class="form-group mt-2">
          <label for="Commission" class="form-label">{{ 'priceCalculatorDialog.galleryCommission' | transloco }}</label>
          <p-dropdown id="Commission" name="Commission" appendTo="body"
            (onChange)="onGalleryCommissionChanged($event)" [options]="galleryCommissionOptions"
          [(ngModel)]="calcParams.galleryCommission"></p-dropdown>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group mt-2">
          <label for="Tax" class="form-label">{{ 'priceCalculatorDialog.totalSalesTax' | transloco }}</label>
          <p-dropdown id="Tax" name="Tax" [options]="taxOptions" appendTo="body"
          (onChange)="onSalesTaxChanged($event)" [(ngModel)]="calcParams.salesTax"></p-dropdown>
        </div>
      </div>
      <div class="description text-secondry mt-3 mb-2">
        {{ 'priceCalculatorDialog.enterRetailOrRevenue' | transloco }}
      </div>
      <hr>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="retailPrice" class="form-label">{{ 'priceCalculatorDialog.retailPrice' | transloco }}</label>
            <input type="number" id="retailPrice" name="retailPrice" class="form-control"
              [(ngModel)]="calcParams.retailPrice" (change)="calculateArtistRevenueFromRetailPrice($event)"  min="0"
              [placeholder]="'priceCalculatorDialog.galleryPriceToCustomer' | transloco" (input)="preventNegativeValues($event,'retailPrice')" />
              <div class="small text-muted mt-1"><i class="fa fa-info-circle me-2"></i> {{ 'priceCalculatorDialog.galleryPriceToCustomer' | transloco }}</div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="artistRevenue" class="form-label">{{ 'priceCalculatorDialog.artistRevenue' | transloco }}</label>
            <input type="number" id="artistRevenue" name="ArtistRevenue" class="form-control"
              [(ngModel)]="calcParams.artistRevenue" (change)="calculateRetailPriceFromArtistRevenue($event)" min="0"
              [placeholder]="'priceCalculatorDialog.revenueToArtist' | transloco" (input)="preventNegativeValues($event,'artistRevenue')" />
              <div class="small text-muted mt-2"><i class="fa fa-info-circle me-1"></i> {{ 'priceCalculatorDialog.revenueToTheArtist' | transloco }}
            </div>
          </div>
        </div>
      </div>

      @if (showRecalculatingPriceInfo) {
        <div class="row text-success mt-2">
          <div class="col-12">
            {{ 'priceCalculatorDialog.recalculatedRetailPrice' | transloco }}
          </div>
        </div>
      }

      <div class="d-flex flex-row justify-content-end mt-4">
        <button type="button" pButton [label]="'priceCalculatorDialog.injectArtistRevenue' | transloco" icon="fa fa-arrow-down"
          class="p-button p-button-outlined" [disabled]="!calcParams.artistRevenue"
        (click)="injectArtistRevenue($event)"></button>
      </div>
    </form>
  </p-dialog>